import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Box, Button, TextField, Stack, Grid2, Snackbar, Alert, Typography, Card, CardContent, CardHeader } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { StyledTableCell, StyledTableRow } from '../../theme';
import { useNavigate, useParams } from "react-router-dom";
import { InvokeAPI } from "../../apis/API";
import AsyncButton from "../../components/common/AsyncButton";
import { getUserMgmtBase } from "../../config/apiBase";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import LockIcon from "@mui/icons-material/Lock";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { ArrowBack } from "@mui/icons-material";

const EnrolledEdit = () => {
    const { user, logout } = useAuth();
    const { id } = useParams();
    const navigate = useNavigate();

    const [enrolledUser, setEnrolledUser] = useState({})

    const getEnrolledUser = async () => {
        const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/enrolled/info`,
            { "UserID": id },
            'POST',
            { "authorization": user["token"] },
            false)
        if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
            logout(user);
        }
        //console.log(uinfo.response)
        return uinfo.response["UserDetails"]
    }

    useEffect(() => {
        //Some function
        getEnrolledUser().then(data => setEnrolledUser(data))
    }, [])

    const [state, setState] = useState({ open: false, severity: "", message: "" })
    const handleClose = () => {
        setState({ ...state, open: false });
    };


    const RenderCurrent = () => {
        return (

            <Box sx={{ marginBottom: "20px" }}>
                <Card
                    elevation={6}
                    sx={{
                        borderRadius: 4,
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                            boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                            transform: 'translateY(-2px)',
                        },
                    }}
                >
                    <CardHeader 
                        sx={{ textAlign: 'center', pb: 1 }}
                        title={
                            <Typography 
                                sx={{ 
                                    fontWeight: 600,
                                    fontSize: '1.125rem',
                                    color: 'text.primary',
                                    letterSpacing: '-0.01em',
                                    textAlign: 'center',
                                    width: '100%'
                                }} 
                                variant="h6"
                            >
                                Details
                            </Typography>
                        } 
                    />
                    <CardContent>
                        <Box sx={{ borderRadius: '0 0 12px 12px', overflow: 'hidden' }}>
                            <TableContainer>
                                <Table sx={{ width: "auto" }}>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell align="right" sx={{ fontWeight: 600 }}>UserName : </StyledTableCell>
                                            <StyledTableCell>{enrolledUser["Username"]}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell align="right" sx={{ fontWeight: 600 }}>First Name : </StyledTableCell>
                                            {enrolledUser["FirstName"] === "" && <StyledTableCell >-Not Provided-</StyledTableCell>}
                                            {enrolledUser["FirstName"] !== "" && <StyledTableCell >{enrolledUser["FirstName"]}</StyledTableCell>}
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell align="right" sx={{ fontWeight: 600 }}>Last Name : </StyledTableCell>
                                            {enrolledUser["LastName"] === "" && <StyledTableCell >-Not Provided-</StyledTableCell>}
                                            {enrolledUser["LastName"] !== "" && <StyledTableCell >{enrolledUser["LastName"]}</StyledTableCell>}
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        )
    }

    const RenderUpdate = () => {
        const [profileData, setProfileData] = useState({
            id: id,
            username: enrolledUser["Username"],
            fname: enrolledUser["FirstName"],
            lname: enrolledUser["LastName"],
        }
        );
        const handleEditChange = (e) => {
            e.preventDefault();
            const { name, value } = e.target;
            setProfileData({ ...profileData, [name]: value });
        };

        const handleUpdateUser = async (e) => {
            e.preventDefault();
            if (profileData["username"] === "") {
                profileData["username"] = enrolledUser["Username"]
            }
            if (profileData["fname"] === "") {
                profileData["fname"] = enrolledUser["FirstName"]
            }
            if (profileData["lname"] === "") {
                profileData["lname"] = enrolledUser["LastName"]
            }
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/enrolled/update`,
                {
                    "ID": id,
                    "Username": profileData.username,
                    "FirstName": profileData.fname,
                    "LastName": profileData.lname,

                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            if (uinfo.iserror) {
                setState({ open: true, severity: "error", message: "Failed to update the profile." })
            } else {
                setState({ open: true, severity: "success", message: "Your profile is updated." })
                getEnrolledUser().then(data => setEnrolledUser(data))
            }
        }
        return (
            <Box sx={{ marginBottom: "20px" }}>
                <Card
                    elevation={6}
                    sx={{
                        borderRadius: 4,
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                            boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                            transform: 'translateY(-2px)',
                        },
                    }}
                >
                    <CardHeader 
                        sx={{ textAlign: 'center', pb: 1 }}
                        title={
                            <Typography 
                                sx={{ 
                                    fontWeight: 600,
                                    fontSize: '1.125rem',
                                    color: 'text.primary',
                                    letterSpacing: '-0.01em',
                                    textAlign: 'center',
                                    width: '100%'
                                }} 
                                variant="h6"
                            >
                                Edit Profile
                            </Typography>
                        } 
                    />
                    <CardContent>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Stack>
                        <Box display="flex" alignItems="center" gap={1} mb={2}>
                            <AccountCircleIcon color="primary" />
                            <TextField
                                label="Username"
                                variant="outlined"
                                name="username"
                                value={profileData["username"]}
                                onChange={handleEditChange}
                                sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                                autoComplete="true"
                            />
                        </Box>
                        <Box display="flex" alignItems="center" gap={1} mb={2}>
                            <PersonIcon sx={{ color: "black" }} />
                            <TextField
                                label="First Name"
                                variant="outlined"
                                name="fname"
                                value={profileData["fname"]}
                                onChange={handleEditChange}
                                sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                                autoComplete="true"
                            />
                        </Box>
                        <Box display="flex" alignItems="center" gap={1} mb={2}>
                            <BadgeIcon sx={{ color: "purple" }} />
                            <TextField
                                label="Last Name"
                                variant="outlined"
                                name="lname"
                                value={profileData["lname"]}
                                onChange={handleEditChange}
                                sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                                autoComplete="true"
                            />
                        </Box>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <AsyncButton 
                                type="submit" 
                                variant="contained" 
                                color="primary" 
                                onClick={handleUpdateUser}
                                sx={{
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: (theme) => theme.shadows[8],
                                    },
                                }}
                            >
                                Update
                            </AsyncButton>
                        </Box>
                    </Stack>
                </Box>
                    </CardContent>
                </Card>
            </Box>
        );
    };
    const RenderUpdatePassword = () => {
        const [profileData, setProfileData] = useState({
            id: id,
            password: "",
        }
        );

        const [showPassword, setShowPassword] = useState(false);
        const handleClickShowPassword = () => setShowPassword((show) => !show);

        const handleMouseDownPassword = (event) => {
            event.preventDefault();
        };

        const handleMouseUpPassword = (event) => {
            event.preventDefault();
        };

        const handleEditChange = (e) => {
            e.preventDefault();
            const { name, value } = e.target;
            setProfileData({ ...profileData, [name]: value });
        };

        const handleUpdatePassword = async (e) => {
            e.preventDefault();
            if (profileData["username"] === "") {
                profileData["username"] = enrolledUser["Username"]
            }
            if (profileData["fname"] === "") {
                profileData["fname"] = enrolledUser["FirstName"]
            }
            if (profileData["lname"] === "") {
                profileData["lname"] = enrolledUser["LastName"]
            }
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/enrolled/password/update`,
                {
                    "ID": id,
                    "Password": profileData.password,
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            if (uinfo.iserror) {
                setState({ open: true, severity: "error", message: "Failed to update the password." })
            } else {
                setState({ open: true, severity: "success", message: "Password is updated." })
            }
        }
        return (
            <Box sx={{ marginBottom: "10px" }}>
                <Card
                    elevation={6}
                    sx={{
                        borderRadius: 4,
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                            boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                            transform: 'translateY(-2px)',
                        },
                    }}
                >
                    <CardHeader 
                        sx={{ textAlign: 'center', pb: 1 }}
                        title={
                            <Typography 
                                sx={{ 
                                    fontWeight: 600,
                                    fontSize: '1.125rem',
                                    color: 'text.primary',
                                    letterSpacing: '-0.01em',
                                    textAlign: 'center',
                                    width: '100%'
                                }} 
                                variant="h6"
                            >
                                Update Password
                            </Typography>
                        } 
                    />
                    <CardContent>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Stack>
                        <Box display="flex" alignItems="center" gap={1} mb={2}>
                            <LockIcon sx={{ color: "orange" }} />
                            <TextField
                                type={showPassword ? 'text' : 'password'}
                                slotProps={{
                                    input: {
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={
                                                        showPassword ? 'hide the password' : 'display the password'
                                                    }
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    onMouseUp={handleMouseUpPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    },
                                }}
                                label="Password"
                                name="password"
                                onChange={handleEditChange}
                                required
                                fullWidth
                                sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}

                            />
                        </Box>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <AsyncButton 
                                type="submit" 
                                variant="contained" 
                                color="primary" 
                                onClick={handleUpdatePassword}
                                sx={{
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: (theme) => theme.shadows[8],
                                    },
                                }}
                            >
                                Update Password
                            </AsyncButton>
                        </Box>
                    </Stack>
                </Box>
                    </CardContent>
                </Card>
            </Box>
        );
    };

    return (
        <Box sx={{ overflow: 'auto', scrollbarWidth: 'thin', paddingBottom: '80px' }}>
            <Button
                variant="text"
                startIcon={<ArrowBack />}
                onClick={() => navigate(-1)}
                sx={{ color: "blue" }}
            >
                Go Back
            </Button>
            <Stack>
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={state.open}
                    onClose={handleClose}
                    key={state.message}
                    autoHideDuration={1000}
                >
                    <Alert variant="filled" severity={state.severity}>
                        {state.message}
                    </Alert>
                </Snackbar>

                <Box>
                    <Grid2 container spacing={2}>
                        <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                            <RenderUpdate />
                        </Grid2>

                        <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                            <RenderUpdatePassword />
                        </Grid2>
                    </Grid2>
                </Box>

            </Stack>
        </Box>
    );
};

export default EnrolledEdit;